import {
  Auth,
  signInWithPopup,
  signOut,
  GoogleAuthProvider,
} from "firebase/auth";
import { ExtendedUser } from "./app";

const googleProvider = new GoogleAuthProvider();

export function Login({
  auth,
  user,
}: {
  auth: Auth;
  user?: ExtendedUser | null;
}) {
  const loginButton = (
    <button onClick={() => signInWithPopup(auth, googleProvider)}>login</button>
  );
  const logoutButton = <button className="clear" onClick={() => signOut(auth)}>logout</button>;
  let message = "..."; // checking login status
  if (user === null) {
    message = "not logged in";
  } else if (user !== undefined) {
    message = `Signed in as ${user.email} ${
      user?.isAdmin ? "(admin)" : "(non-admin)"
    }`;
  }
  return (
    <div className="login-container">
      <div>{message}</div>
      {user != null && logoutButton}
      {user === null && loginButton}
    </div>
  );
}
